export default __webpack_public_path__ + "/assets/primo-piano.png";